import { atom } from 'jotai';

import { sidecarUpdateAtom } from '../_graphql/mutationSidecarUpdate';
import { sidecarDetailQueryAtom } from '../_graphql/querySidecarDetail';

import { settingsRouteParamAtom } from './settingsModule.state';

export const $sidecarId = settingsRouteParamAtom(
  ['/hardware/sidecars/:id'],
  'id',
);

export const $remoteSidecarDetail = sidecarDetailQueryAtom((get) => {
  const sidecarId = get($sidecarId);
  return {
    variables: {
      ids: sidecarId ? [sidecarId] : [],
    },
    skip: !sidecarId,
  };
});

export const $isSidecarLoading = atom((get) => {
  const data = get($remoteSidecarDetail);
  return data?.isLoading ?? false;
});

export const $sidecarError = atom((get) => {
  const data = get($remoteSidecarDetail);
  return data?.error ?? null;
});

export const $updateSidecar = sidecarUpdateAtom({
  onSuccess: (get) => {
    get($remoteSidecarDetail).refetch?.();
  },
});
